import { jsx } from "react/jsx-runtime";
import { skeletonStyle } from "./Skeleton.css.mjs";
import { Box } from "../Box/Box.mjs";
const Shape = ({
  width = "100%",
  height = "100%",
  borderRadius = "small"
}) => /* @__PURE__ */ jsx(
  Box,
  {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    style: { width, height },
    className: skeletonStyle,
    borderRadius
  }
);
export {
  Shape
};
